import { Component, OnInit } from '@angular/core';
import { DataService } from "../shared/dataservice.service";

@Component({
  selector: 'app-daily-act',
  templateUrl: './daily-act.component.html',
  styleUrls: ['./daily-act.component.css']
})
export class DailyActComponent implements OnInit {

  constructor(public _dataService:DataService) { }

  ngOnInit() {
    this._dataService.currPageName = "Daily Activities";
  }

}
